var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhotoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.637 2.383a.3.3 0 00-.301.3v12.633a.3.3 0 00.3.301H3.77a.97.97 0 01.034-.036l7.312-7.312a2.106 2.106 0 012.902-.073l3.96 3.583V2.684a.3.3 0 00-.301-.301H2.636zm15.039 13.234H6.319l6.072-6.072a.3.3 0 01.415-.01l5.17 4.678v1.104a.3.3 0 01-.3.3zm2.105-.3V2.684A2.105 2.105 0 0017.676.578H2.636A2.105 2.105 0 00.532 2.684v12.633c0 1.162.943 2.105 2.106 2.105h15.039a2.105 2.105 0 002.105-2.106zM7.148 6.593a.602.602 0 11-1.203 0 .602.602 0 011.203 0zm1.805 0a2.406 2.406 0 11-4.812 0 2.406 2.406 0 014.812 0z",
    fill: "#7C8193"
  })));
}
export default __webpack_public_path__ + "media/images/photoIcon-d01940b1.svg";
export { SvgPhotoIcon as ReactComponent };